import React from 'react';
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changeSidebarState } from "../../redux/reducers/sidebar-reducer";
import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Settings from '@mui/icons-material/Settings';
import { logoutUser } from '../../redux/reducers/user-reducer'
import { openDialogCambioPassword } from '../../redux/reducers/dialogCambioPassword-reducer';
import DialogCambioPassword from '../../components/UI/Dialog/DialogCambioPassword';

const redirectLogout = '/';
const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open'
})
(({ theme, open }) => ({
 zIndex: theme.zIndex.drawer + 1,
 transition: theme.transitions.create(['width', 'margin'], {
   easing: theme.transitions.easing.sharp,
   duration: theme.transitions.duration.leavingScreen
}),
...(open && {
   marginLeft: drawerWidth,
   width: `calc(100% - ${drawerWidth}px)`,
   transition: theme.transitions.create(['width', 'margin'], {
     easing: theme.transitions.easing.sharp,
     duration: theme.transitions.duration.enteringScreen
   })
 }),
 backgroundColor: '#3e6bb4'
}));


const Navbar = ({ initialState, xsSize }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [anchorElement, setAnchorElement] = useState(null);
    const open = Boolean(anchorElement);
  
    const handleMenuClick = (event) => {
        setAnchorElement(event.currentTarget);
     };
  
    const handleCloseMenu = () => {
        setAnchorElement(null);
    };

    const { sidebar } = initialState;
    const [sidebarState, setSidebarState] = useState(sidebar);

    useEffect(() => {
        setSidebarState(sidebar);
    }, [sidebar]);

const logoutToLogin = () => {
    dispatch(logoutUser());
    navigate(redirectLogout)
}

    return (
        <>
            <AppBar position="absolute" open={sidebarState} sx={{width: xsSize || !sidebarState ? '100%' : `calc(100% - ${drawerWidth}px)`}}>
                <Toolbar className="navbar" sx={{ pr: '24px' }} >
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={() => dispatch(changeSidebarState())}
                        sx={{
                            marginRight: '36px',
                            ...(sidebarState && { display: 'none' }),
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        component="h1"
                        variant="h6"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, fontWeigth: 'bold' }}
                    >
                    CALL DETECTOR
                    </Typography>
                    <IconButton 
                        color="inherit"
                        id="basic-button"
                        aria-controls="basic-menu"
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleMenuClick}
                    >
                        <Settings />
                    </IconButton>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorElement}
                        open={open}
                        onClose={handleCloseMenu}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                        sx={{"& .MuiPaper-root": {minWidth:"300px"}}}
                    >
                        {/* {NavbarData.map((link) => {
                            return (
                            <MenuItem key={link.name} onClick={() => navigate(link.path)}>
                                {link.name}
                            </MenuItem>
                            );
                        })} */}
                        <MenuItem key="CambioPsw" onClick={() => {dispatch(openDialogCambioPassword("cambioPsw"))}}>
                            Cambio Password
                        </MenuItem>
                        <MenuItem key="Logout" onClick={() => {logoutToLogin()}}>
                            Logout
                        </MenuItem>
                    </Menu>
                </Toolbar>
            </AppBar>
            <DialogCambioPassword />
        </>
    )
};

export default Navbar;
